import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  return (
    <footer role="contentinfo" className="py-8 flex justify-center">
      <a
        href="https://www.davmc.com"
        alt="David McGregor"
        className="text-white text-sm font-mono"
      >
        <span>
          &copy; {new Date().getFullYear()} David McGregor <FontAwesomeIcon icon={faLink} />
        </span>
      </a>
    </footer>
  );
};

export default Footer;
